import Component from '../abstracts/Component';

export default class SizeTableSwitcherComponent extends Component {

  get SELECTORS() {
    return {
        main: '.jsSizeTableSwitcher',
        tableContainer: '.l-s-g__size-row',
        sizesRow: '.l-s-g__size-row__sizes:not(.reference-row)',
        referenceRow: '.reference-row',
        tableShowed: '.show-table',
        labelTableRef: '.jsSizeTableReference',
    };
  }

  constructor() {
    super();
    
    this.cssVexClass= 'size-guide';
    this.customCloseClass = 'size-guide-close';
    this.showTableClass = 'show-table';
  }
  
  initSwitcher(){
      let allSizeContainers= document.querySelectorAll(this.SELECTORS.tableContainer);
      let allsizesRow = document.querySelectorAll(this.SELECTORS.sizesRow);
      for (let container of allSizeContainers){
          this.createSwitcherOptions(container);
          this.initSwitcherListener(container);
          this.setReferenceLabel(container);
      }
  }
  setReferenceLabel(container){
      let labelRef = container.querySelector(this.SELECTORS.labelTableRef);
      let refRow = container.querySelector(this.SELECTORS.referenceRow);
      try{
          labelRef.innerText = refRow.dataset.localeLabel;
      }catch(err){
          console.error(err);
      }
  }
  createSwitcherOptions(container){
      let sizeRows = container.querySelectorAll(this.SELECTORS.sizesRow);
      let switcherInput = container.querySelector(this.SELECTORS.main);
      for (let row of sizeRows){
          let optEl = document.createElement('option');
          let rowLabel = row.dataset.localeLabel;
          optEl.value = rowLabel;
          optEl.innerText = rowLabel;
          switcherInput.append(optEl);
      }
  }
  initSwitcherListener(container){
      let switcher= container.querySelector(this.SELECTORS.main);
      switcher.addEventListener('change', ()=>{
          this.hideLocales(container);
          this.setVisibilelocaleTable(switcher.value,container);
      });
      let firstValue= switcher.value;
      this.setVisibilelocaleTable(firstValue,container);
  }
  setVisibilelocaleTable(tableLabel,container){
      let cssClass = this.showTableClass;
      let tableEl = container.querySelector(`[data-locale-label="${tableLabel}"]`);
      tableEl.classList.add(cssClass);
  }
  hideLocales(container){
      let sizeRows = container.querySelectorAll(this.SELECTORS.tableShowed);
      try{
          for(let row of sizeRows){
              row.classList.remove(this.showTableClass);
          }
      }catch (error){
          console.log(error);
      }
  }
  render() {
    
    if(document.querySelector(this.SELECTORS.main)){
        this.initSwitcher();
    }

    let myName = this.constructor.name;
    console.log(`[${myName}] Rendering..`);
  }
}
